const tokenOrigins = {
  CLARO_VIP_SMS_INCENTIVE: "claroVipSMSIncentive",
  CLARO_VIP_SCHEDULE_MANAGER: "claroVipScheduleManager",
  CLARO_VIP_NEW_RECHARGE: "claroVipNewRecharge",
};

export default tokenOrigins;
